import { escapeHTML } from "@wordpress/escape-html";

import { useBlockProps } from '@wordpress/block-editor';

export default (props) => {
	const { attributes } = props;
	const max = attributes.maxRating;
	const starAmount = attributes.starAmount;
	const rating = attributes.rating;
	const ratingToStarAmount = parseFloat(starAmount * (rating / max));
	const starRatingPercent = ((ratingToStarAmount % 1) * 100).toFixed(2) + "%";

	const blockProps = props.editor ? useBlockProps({className: 'sptcrb__rating__block_wrapper'}) : useBlockProps.save({className: 'sptcrb__rating__block_wrapper'});

	const Stars = () => {
		var stars = [];
		for (var i = 1; i <= parseInt(starAmount); i++) {
			let starclass = i <= ratingToStarAmount ? " filled" : " empty";
			starclass =
				i > ratingToStarAmount &&
				ratingToStarAmount % 1.0 === ratingToStarAmount % (i - 1.0)
					? " percent"
					: starclass;
			stars.push(
				React.createElement(
					"div",
					{
						class: "sptcrb__rating__block__header__stars_item" + starclass,
					},
					React.createElement("i", {
						class: "fas fa-star",
					})
				)
			);
		}
		return stars;
	};

	const RatingBars = () => {
		return attributes.reviews.map((item) => (
			<div class="sptcrb__rating__block__ratingbar__item">
				<h4>{escapeHTML(item.title)}</h4>
				<div class="sptcrb__rating__block__ratingbar__item_rating">
					<div
						class="sptcrb__rating__block__ratingbar__item_rating__inner"
						style={{
							width: `${(parseFloat(item.rating) / max) * 100}%`,
						}}
					></div>
				</div>
			</div>
		));
	};

	return (
		<div {...blockProps}>
			<div class="sptcrb__rating__block__header">
				<h3>
					<span>{escapeHTML(attributes.ratingText)}:</span>{" "}
					{escapeHTML(attributes.rating.toString())}
				</h3>
				<div
					className="sptcrb__rating__block__header__stars"
					style={{ "--spbblocks-rating-block-percentage": starRatingPercent }}
				>
					<Stars />
				</div>
			</div>
			<div className="sptcrb__rating__block__ratingbar">
				<RatingBars />
			</div>
		</div>
	);
};
